module.exports = __webpack_public_path__ + "img/ic_ycpx_ok.be5b919b.png";